// extracted by mini-css-extract-plugin
export default {"BigPlay":"BigPlayButton_BigPlay__IlzIG","BigPlayIcon":"BigPlayButton_BigPlayIcon__TnMjV"};